import * as yup from 'yup'
import { getCreditCardCVV } from 'src/deps/validationSchemaDeps'

export function cardCVVSchema(card = {}, { isCvvInputBound = true } = {}) {
  if (!isCvvInputBound) {
    return yup.object({})
  }
  const provider = card?.provider || ''
  const cardType =
    provider === 'AMEX' || provider === 'american_express'
      ? 'AMERICAN_EXPRESS'
      : provider
  const cvvSchema = Object.assign({}, getCreditCardCVV({ cardType }))
  return yup.object(cvvSchema)
}
